import { SettingsFormPageButtonBar } from "@babackapp/react-hook-forms-components/form-page";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import { Form, FormField } from "@babackapp/ui/components/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import useTranslation from "@babackapp/translations/use-translation";

import { z } from "zod";

const ShopifyNotificationsFormSchema = z.object({
  emails: z.boolean(),
  refundEmail: z.boolean(),
  labelEmail: z.boolean(),
  giftCardEmail: z.boolean(),
});

export type ShopifyNotificationsFormValues = z.infer<
  typeof ShopifyNotificationsFormSchema
>;

type Props = {
  onSubmit: (data: ShopifyNotificationsFormValues) => void;
  defaultValues: ShopifyNotificationsFormValues;
  /**
   * Hides the gift card switch only — the value stays in the payload, since
   * `shopifyEmails` is written whole and omitting the key would reset it.
   */
  isGiftCardMode: boolean;
};

export const ShopifyPreferencesNotificationsForm = ({
  onSubmit,
  defaultValues,
  isGiftCardMode,
}: Props) => {
  const t = useTranslation();

  const form = useForm<ShopifyNotificationsFormValues>({
    resolver: zodResolver(ShopifyNotificationsFormSchema),
    defaultValues,
  });
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col justify-start gap-8 mt-8"
      >
        <FormField
          name="emails"
          render={({ field }) => (
            <FormSwitch
              label={t(
                "settings.customerPortal.notifications.emailsBaback.title",
              )}
              description={t(
                "settings.customerPortal.notifications.emailsBaback.description",
              )}
              {...field}
            />
          )}
        />
        <FormField
          name="refundEmail"
          render={({ field }) => (
            <FormSwitch
              label={t(
                "settings.customerPortal.notifications.refundEmailShopify.title",
              )}
              description={t(
                "settings.customerPortal.notifications.refundEmailShopify.description",
              )}
              {...field}
            />
          )}
        />

        <FormField
          name="labelEmail"
          render={({ field }) => (
            <FormSwitch
              label={t(
                "settings.customerPortal.notifications.labelEmailShopify.title",
              )}
              description={t(
                "settings.customerPortal.notifications.labelEmailShopify.description",
              )}
              {...field}
            />
          )}
        />

        {isGiftCardMode && (
          <FormField
            name="giftCardEmail"
            render={({ field }) => (
              <FormSwitch
                label={t(
                  "settings.customerPortal.notifications.giftCardEmailShopify.title",
                )}
                description={t(
                  "settings.customerPortal.notifications.giftCardEmailShopify.description",
                )}
                {...field}
              />
            )}
          />
        )}

        <SettingsFormPageButtonBar />
      </form>
    </Form>
  );
};
